import { createSlice } from "@reduxjs/toolkit";
import { getFacultyMonthBilling, FacultyMonthBillPaid } from "../../builders/faculty/facultybilling.builder";

const initialState = {
    loading: false,
    facultyMonthBillData: [],
    isFacultyBillPaid: "unpaid",
    billingCalenderMonthAndYear: "",
    currentMonthNumber: new Date().getMonth() + 1, // Month number (1-12)
    currentYear: new Date().getFullYear() // Current year
};

const facultyMonthBillingSlice = createSlice({
    name: "facultyMonthBilling",
    initialState,
    reducers: {
        clearExtraReducers: (state) => {
            state.loading = false;
            state.facultyMonthBillData = [];
        },
        billingMonthAndYear: (state, action) => {
            state.billingCalenderMonthAndYear = action.payload;
        },
        setCurrentMonthNumber: (state, action) => {
            state.currentMonthNumber = action.payload;
        },
        setCurrentYear: (state, action) => {
            state.currentYear = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getFacultyMonthBilling.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getFacultyMonthBilling.fulfilled, (state, action) => {
            state.loading = false;
            state.facultyMonthBillData = action.payload;
        });
        builder.addCase(getFacultyMonthBilling.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(FacultyMonthBillPaid.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(FacultyMonthBillPaid.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(FacultyMonthBillPaid.rejected, (state) => {
            state.loading = false;
        });
    }
});

export const { billingMonthAndYear, setCurrentMonthNumber, setCurrentYear } = facultyMonthBillingSlice.actions;

export default facultyMonthBillingSlice.reducer;

